<template>
  <div :class="'m-tile ' + color">
    <a :href="url" class="m-tile__link">
      <div v-if="image !== ''" class="m-tile__picture">
        <picture>
          <source :srcset="imageSrcFull" />
          <img class="m-tile__picture-image" :src="imageSrc" />
        </picture>
      </div>
      <div v-else class="m-tile__picture m-tile__picture--placeholder"></div>
      <div class="m-tile__content h-remove-child-margin">
        <div class="m-tile__content-section h-remove-child-margin">
          <h3 class="m-tile__title">
            {{ title }}
          </h3>
          <p v-html="description" />
        </div>
        <div class="m-tile__content-section">
          <slot name="badges" />
          <div class="m-tile__details">
            <slot />
            <span class="m-tile__details-city">{{ city }}</span>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: false,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    city: {
      type: String,
      required: true
    }
  },
  computed: {
    imageSrcFull: function() {
      return this.image + '?mode=crop&upscale=false&width=480&height=270&format=jpeg, ' + this.image + '?mode=crop&upscale=false&width=720&height=405&format=jpeg 2x'
    },
    imageSrc: function() {
      return this.image + '?mode=crop&upscale=false&width=480&height=270&format=jpeg'
    }
  }
}
</script>
